export default "__VITE_ASSET__7f167520__"